<div class="row g-0">
  <div class="col-12 col-lg-6">
    <h5>Scan</h5>
    <p class="me-1">Scan the following QR code with the <b>device</b>: <br /></p>
    <p class="text-center text-lg-left"
       [style.height]="qrGenOptions.width + 'px'">
      @if (code) {
      <ml-qr-code [value]="pairUrlWithCode"
                  [options]="qrGenOptions"></ml-qr-code>
      }
    </p>
    @if (this.environmentService.environment.local && code['ips']) {
    <div [formGroup]="formGroup">
      <span>{{ pairUrlWithCode }}</span>
      <select formControlName="host"
              class="form-select">
        <option>localhost</option>
        @for (ip of code['ips']; track ip) {
        <option>{{ ip }}</option>
        }
      </select>
    </div>
    }
  </div>
  <div class="col-12 col-lg-6"
       [hidden]="!noQRCodeScanner">
    <h5>Manual</h5>
    <p>
      Navigate to: <u>{{ pairUrl }}</u>, <br />
      in <b>Safari</b> on the <b>device</b> and enter the code:
    </p>
    <div class="d-flex flex-nowrap justify-content-center justify-content-lg-start">
      @for (codeChar of codeChars; track codeChar) {
      <div class="bg-primary px-2 py-1 me-1 text-white">
        {{ codeChar }}
      </div>
      }
    </div>
  </div>
  @if (!noQRCodeScanner) {
  <div class="col-12 col-lg-6 d-flex justify-content-end align-items-end">
    <button class="btn btn-link ms-auto"
            (click)="noQRCodeScanner = true">I don't have a QR code scanner</button>
  </div>
  }
</div>